<div class="grid-x">
    <div class="cell">
        <ag-grid-angular [gridOptions]="gridOptions" [rowData]="dataObservable$ | async" class="data-grid " [excelStyles]="excelStyles" [attr.aria-label]="gridAriaLabel"></ag-grid-angular>
    </div>
</div>